import React, { useMemo, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
  updateShortPeriod,
  getShortDateRange,
  DATE_RANGE_SHORT_LAST_WEEK,
  DATE_RANGE_SHORT_LAST_MONTH,
  DATE_RANGE_SHORT_LAST_3_MONTHS,
  DATE_RANGE_SHORT_CUSTOM,
} from '../../../store/dateRange'

const DateRangeShortPeriod = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const range = useSelector(getShortDateRange)

  const options = useMemo(
    () => [
      {
        value: DATE_RANGE_SHORT_LAST_WEEK,
        label: t('consumption.daterange.lastWeek'),
      },
      {
        value: DATE_RANGE_SHORT_LAST_MONTH,
        label: t('consumption.daterange.lastMonth'),
      },
      {
        value: DATE_RANGE_SHORT_LAST_3_MONTHS,
        label: t('consumption.daterange.last3months'),
      },
      {
        value: DATE_RANGE_SHORT_CUSTOM,
        label: t('consumption.daterange.custom'),
      },
    ],
    [t],
  )

  const onChange = useCallback(
    (e) => {
      dispatch(updateShortPeriod(e.target.value))
    },
    [dispatch],
  )

  return (
    <select
      value={range.period}
      onChange={onChange}
      css={{
        border: 0,
        fontSize: 14,
        padding: 0,
        color: 'var(--gar-dark)',
        '&:focus': {
          outline: 'none',
        },
      }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default DateRangeShortPeriod
